import { render, staticRenderFns } from "./CaseContainer.vue?vue&type=template&id=4f240364"
import script from "./CaseContainer.vue?vue&type=script&lang=js"
export * from "./CaseContainer.vue?vue&type=script&lang=js"
import style0 from "./CaseContainer.vue?vue&type=style&index=0&id=4f240364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports